var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FocusTrap"},[_c('div',{staticClass:"focus-trapper",attrs:{"tabindex":"0"}}),_vm._t("default"),_c('div',{staticClass:"focus-trapper",attrs:{"tabindex":"0"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }